module.exports = __webpack_public_path__ + "static/media/svg.617b5f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/svg.png
// module id = 2572
// module chunks = 0